import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Switch extends PureComponent {
  render() {
    const { className, ...others } = this.props;
    const cls = classNames({
      "weui-switch": true
    }, className);

    return (
      <input className={ cls } type="checkbox" { ...others } />
    );
  }
}
